import { render, staticRenderFns } from "./ClaimCard.vue?vue&type=template&id=5cff8222&scoped=true"
import script from "./ClaimCard.vue?vue&type=script&lang=js"
export * from "./ClaimCard.vue?vue&type=script&lang=js"
import style0 from "./ClaimCard.vue?vue&type=style&index=0&id=5cff8222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff8222",
  null
  
)

export default component.exports